import React, { useState, useContext, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Link, useSearchParams, useLocation, useNavigate } from "react-router-dom";
import { GlobalStateContext } from "../../context/GlobalStateContext";
import GetLevantaProductsData from "../../hooks/get-levanta-products";
import HeaderCategoriesDropdown from "../HeaderCategoriesDropdown";

const Header = ({ data, setSearchTitle }) => {
  const [searchValue, setSearchValue] = useState("");
  const { setSearchResults, setSugestedProducts, setProductsList, setLoading } =
    useContext(GlobalStateContext);
  const allCategories = useSelector(
    (state) => state.dataUploader.allCategories,
  );
  const mainCategories = useSelector(
    (state) => state.dataUploader.mainCategories,
  );
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [queryParameters] = useSearchParams();
  const queryParams = [];
  if (queryParameters.get("gclid")) {
    queryParams.push("gclid=" + queryParameters.get("gclid"));
  }

  const menuRef = useRef(null);
  const placeholderRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const menu = menuRef.current;
      const placeholder = placeholderRef.current;
      if (menu && placeholder) {
        const menuH = menu.offsetHeight;
        const topHeaderH = 0;
        const headerCampaign = 0;
        const targetScroll = topHeaderH + headerCampaign;
        if (window.scrollY > targetScroll) {
          menu.classList.add('axil-sticky');
          placeholder.style.height = `${menuH}px`;
        } else {
          menu.classList.remove('axil-sticky');
          placeholder.style.height = '0px';
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (pathname.startsWith("/product/")) {
      setSearchValue("");
    }
  }, [pathname]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    const body = document.body;
    const nav = document.querySelector('.header-main-nav');
    if (!isMenuOpen) {
      body.classList.add('open');
      nav.classList.add('open');
      const mask = document.createElement('div');
      mask.classList.add('closeMask');
      body.appendChild(mask);
      body.style.overflow = 'hidden';
      mask.addEventListener('click', closeMenu);
    } else {
      closeMenu();
    }
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    const body = document.body;
    const nav = document.querySelector('.header-main-nav');
    body.classList.remove('open');
    nav.classList.remove('open');
    body.style.overflow = '';
    const masks = document.querySelectorAll('.closeMask');
    masks.forEach(mask => mask.remove());
  };

  const removeTitle = () => {
    localStorage.removeItem("categoryName");
    localStorage.removeItem("categoryId");
    localStorage.removeItem("categoryProvider");
  };

  const removeSideMenu = (e) => {
    closeMenu();
  };

  const clearSearch = async () => {
    setSearchValue("");
    setSearchTitle("");
    setSugestedProducts([]);
    setSearchResults([]);
    setProductsList([]);
    setLoading(true);

    if (pathname !== "/") {
      navigate("/");
      return;
    }

    try {
      await GetLevantaProductsData(
        setLoading,
        () => {},
        () => {},
        setProductsList,
        { limit: 8, offset: 0 },
        null,
        () => {},
        () => {},
      );
    } catch (error) {
      setLoading(false);
    }
  };

  const submitSearch = async (e) => {
    e.preventDefault();

    if (!searchValue.trim()) {
      await clearSearch();
      return;
    }

    if (pathname !== "/") {
      navigate("/");
    }

    setSugestedProducts([]);
    setSearchResults([]);
    setProductsList([]);
    setLoading(true);

    try {
      const params = new URLSearchParams({ title: searchValue }).toString();
      await GetLevantaProductsData(
        setLoading,
        () => {},
        () => {},
        (searchData) => {
          if (searchData.length > 0) {
            setSearchTitle("Search results:");
            setSearchResults(searchData);
          } else {
            setLoading(true);
            const params = new URLSearchParams({
              orderBy: "p.ratings_total",
              order: "desc",
            }).toString();
            GetLevantaProductsData(
              setLoading,
              () => {},
              () => {},
              (searchData) => {
                setSearchTitle(
                  "We couldn't find any products by your request. Here are the most popular products:",
                );
                setSearchResults(searchData);
              },
              params,
              null,
              () => {},
              () => {},
            );
          }
        },
        params,
        null,
        () => {},
        () => {},
      );
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      <header className="header axil-header header-style-5">
        <div id="axil-sticky-placeholder" ref={placeholderRef}></div>
        <div className="axil-mainmenu" ref={menuRef}>
          <div className="container">
            <div className="header-navbar">
              <div className="header-brand">
                <a
                  href={
                    "/" +
                    (queryParams.length > 0 ? "?" + queryParams.join("&") : "")
                  }
                  onClick={removeTitle}
                  className="logo logo-dark"
                >
                  <img src={`/images/logo/logo.webp`} alt="Site Logo" width="150" height="24" />
                </a>
              </div>

              <div className="axil-search">
                <form onSubmit={submitSearch}>
                  <input
                    type="text"
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    placeholder="Search for deals, brands, products..."
                  />

                  <button
                    type="submit"
                    className="search-submit-btn"
                    aria-label="Search"
                  >
                    {/* <i className="fas fa-search"></i> */}
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="#D1D5DC" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M17.4993 17.5L13.916 13.9167" stroke="#D1D5DC" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>

                  {searchValue && (
                    <button
                      type="button"
                      className="search-clear-btn"
                      onClick={clearSearch}
                      aria-label="Clear search"
                    >
                      {/* <i className="fas fa-times"></i> */}
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.26536 12.6667L3.33203 11.7334L7.06536 8.00004L3.33203 4.26671L4.26536 3.33337L7.9987 7.06671L11.732 3.33337L12.6654 4.26671L8.93203 8.00004L12.6654 11.7334L11.732 12.6667L7.9987 8.93337L4.26536 12.6667Z" fill="#D1D5DC"/>
                      </svg>
                    </button>
                  )}
                </form>
              </div>

              <div className="header-main-nav">
                <nav className="mainmenu-nav">
                  <button className="mobile-close-btn mobile-nav-toggler" onClick={closeMenu}>
                    <i className="fas fa-times"></i>
                  </button>
                  <ul className="mainmenu">
                    <li>
                      <a
                        href={
                          "/" +
                          (queryParams.length > 0
                            ? "?" + queryParams.join("&")
                            : "")
                        }
                        onClick={removeTitle}
                      >
                        Home
                      </a>
                    </li>
                    {allCategories.length || mainCategories.length > 0 ? (
                      <HeaderCategoriesDropdown
                        data={data}
                        removeSideMenu={removeSideMenu}
                      />
                    ) : null}
                    <li onClick={(e) => removeSideMenu(e)}>
                      <Link to={"/about" + window.location?.search}>
                        About Us
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
              <div className="header-action">
                <ul className="action-list">
                  <li className="axil-mobile-toggle">
                    <button
                      className="menu-btn mobile-nav-toggler"
                      aria-label={"Humburger menu"}
                      onClick={toggleMenu}
                    >
                      <i className="flaticon-menu-2"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
